export default {
  methods: {
    tr (code, key, fallback, param, locale) {
      if (code) {
        const path = `${this.$route.name}${key ? '.' : ''}${key || ''}.${code}`
        const resolved =
          param !== undefined ? this.$tc(path, param, locale) : this.$t(path, locale)
        return path === resolved ? (fallback === undefined ? code : fallback) : resolved
      } else {
        return null
      }
    }
  }
}
